<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ویرایش قانون بهفا</h5>
      <form  >
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">عنوان</label>
              <input [(ngModel)]="Title" name="Title" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            </div>

          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">شرح</label>
              <ckeditor name="editorData" [(ngModel)]="model.editorData" [config]="config" [editor]="Editor"></ckeditor>
            </div>
          </div>

          <br/>
          <br/>

          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="button" (click)="onSubmitForm()"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
          <button routerLink="/BehfaRuleAdmin" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>
